import { render, staticRenderFns } from "./GroupTypeModal.vue?vue&type=template&id=155b47d2&"
import script from "./GroupTypeModal.vue?vue&type=script&lang=ts&"
export * from "./GroupTypeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports